<template>
<div>
    <MenuBar />
    <PageVisit v-if="$i18n.locale==='zh_CN' && (info.admin || info.monitor) && $route.name!='menu' && $route.name!='dim'"/>
    <GlobalAlert v-show="$route.name!='menu' && $route.name!='dim'"/>
    <router-view></router-view>
    <NewPlatformBtn />
    <a-back-top><a-icon type="arrow-up" /></a-back-top>
    <a-popover placement="left" title="跟进UX" overlayClassName="follower_popover" v-if="$i18n.locale==='zh_CN' && (info && info.followers)">
        <template slot="content">
            <div class="follower_item" v-for="(follower,index) in info.followers" :key="index" @click="loadPopo(follower.email)">
                <span class="name">{{follower.type}} {{follower.name}}</span>
                <span class="popo"></span>
            </div>
        </template>
        <div class="ant-back-top-follower"><a-icon type="phone" /></div>
    </a-popover>
</div>
</template>  

<script>
import {BackTop, Popover, Radio, Anchor, DatePicker, Select} from 'ant-design-vue';
import Vue from 'vue'
Vue.use(BackTop)
Vue.use(Popover)
Vue.use(Radio)
Vue.use(Anchor)
Vue.use(DatePicker)
Vue.use(Select)
import {encrypt} from '@/utils/utils'
import MenuBar from '@/components/game/menubar.vue'
import GlobalAlert from '@/components/common/alert.vue'
import NewPlatformBtn from '@/components/game/newPlatformBtn.vue'
import PageVisit from '@/components/game/pagevisit.vue'
export default {
    components: {
        MenuBar,
        GlobalAlert,
        NewPlatformBtn,
        PageVisit,
    },
    computed: {
        info() {
            return this.$store.state.game.info
        }
    },
    data() {
        return {
            visits:[],
            loadPopo(email) {
                const b = {
                    opss: {
                    sstp: 0,
                    ssid: email
                    }
                }
                window.location.href = 'netease-popoapp://' + encrypt(JSON.stringify(b))
            },
        }
    },
}
</script>

<style lang="less" scope>
.follower_popover {
    .ant-popover-title {
        min-width: 150px;
        border-bottom:none;
        padding:15px 20px;
    }
    .ant-popover-inner-content {
        padding:0 0 20px 0;
    }
    .follower_item {
        padding:0 20px;
        line-height: 30px;
        cursor: pointer;
        .name {
            display:inline-block; 
        }
        .popo {
            width:25px; 
            height:25px;
            margin:2px 0 0 0;
            border-radius: 5px;
            background:url(../../assets/img/popo.png) no-repeat;
            float:right;
        }
        &:hover {
            background:#ededed;
        }
    }
}
</style>